<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de origem programática' : 'Cadastro de origem programática'">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/origem-programatica/Form'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.$router.push({name: 'cadastro-origem-programatica-index'})
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
    props: {
        id: {type: Number, default: null}
    },
}
</script>